import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Header/Navbar";
import About from './Pages/About/About';
import ContactUs from './Pages/Contact/ContactUs';
import Cards from './Herosection/Components/Cards';
import Services from './Pages/Services/Service';
import ServiceDetails from './Pages/Services/ServiceDetails';
import Home from './Pages/Home/Home';
import Faq from './Pages/Faq/Faq'
import Footer from './Footer/Footer';
import Privacy from './Pages/Policyes/Privacy';
import Terms from './Pages/Policyes/Terms';
import AOS from 'aos';
import { useEffect } from 'react';
import Enquiry from './Pages/Enquiry/Enquiry';
function App() {

  useEffect(() => {
      AOS.init({
        duration: 1000,
        once: false,
      });
    }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/service/:id" element={<ServiceDetails />} />
        <Route path="/faq" element={<Faq/>} />
        <Route path="/privacy-policy" element={<Privacy/>} />
        <Route path="/terms-conditions" element={<Terms/>} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
